import { useRef } from 'react';

import {
    Layout as PropsLayout,
    Overflow as PropsOverflow,
} from '@/models/Props';

import useSetProperties from '@/helpers/useSetProperties';

import './Overflow.scss';

const Overflow = ({ children, width, height }: PropsLayout & PropsOverflow) => {
    const sectionRef = useRef<HTMLElement>(null);

    const CSSProperties = {
        'overflow-width': width ? `${width}rem` : 'auto',
        'overflow-height': height ? `${height}rem` : 'auto',
        'overflow-x': width ? 'scroll' : 'auto',
        'overflow-y': height ? 'scroll' : 'auto',
    };

    useSetProperties(CSSProperties, sectionRef);

    return (
        <section
            ref={sectionRef}
            aria-label={'Timeline Section'}
            data-overflow={'active'}
        >
            {children}
        </section>
    );
};

export default Overflow;
